/** Owner student list: “Active” status if last attended session is within this many days. */
export const STUDENT_LIST_RECENCY_ACTIVE_WITHIN_DAYS = 90;
